import React from "react";
import { useSubscription } from "../context/SubscriptionContext";
import { useNavigate } from "react-router-dom";
import config from "../config.json";

const SubscriptionUpgrade = () => {
  const { handleSubscribe, handleOpenExternal } = useSubscription();
  const navigate = useNavigate();

  return (
    <div className="container py-3 d-flex align-items-center justify-content-center" style={{ minHeight: "80vh" }}>
      <div className="card upgrade-pro-card shadow-lg border-0 rounded-4 overflow-hidden w-100" style={{ maxWidth: "480px" }}>
        <div
          className="p-4 text-center upgrade-pro-header"
          style={{
            background: "linear-gradient(135deg, #0a180e 0%, #132b1a 100%)",
            borderBottom: "1px solid rgba(34, 197, 94, 0.25)"
          }}
        >
          <div className="d-inline-flex align-items-center justify-content-center p-2 rounded-circle mb-2" style={{ background: "rgba(254, 202, 48, 0.15)", border: "1px solid rgba(254, 202, 48, 0.3)" }}>
            <i className="fi fi-rr-star text-warning" style={{ fontSize: "1.4rem" }}></i>
          </div>
          <h2
            className="fw-bold mb-1 d-flex align-items-center justify-content-center"
            style={{
              background: "linear-gradient(180deg, #feca30 0%, #ffffff 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent"
            }}
          >
            Upgrade to Recipe AI Pro
          </h2>
          <p className="mb-0 text-white-50" style={{ fontSize: "0.85rem" }}>
            Unlock your full cooking potential
          </p>
        </div>

        <div className="card-body p-4 upgrade-pro-body">
          <h6 className="fw-bold mb-3 text-center upgrade-pro-heading">Why Go Pro?</h6>

          <div className="d-flex align-items-center mb-3 p-2 rounded-3 upgrade-feature-item">
            <div className="feature-icon-badge bg-success-subtle p-2 rounded-circle me-3 d-flex align-items-center justify-content-center">
              <i className="fi fi-rr-infinity text-success" style={{ fontSize: "1rem" }}></i>
            </div>
            <div>
              <h6 className="mb-0 fw-bold upgrade-feature-title" style={{ fontSize: "0.88rem" }}>Daily recipe generation</h6>
              <small className="upgrade-feature-desc text-muted">Unlimited inspiration tailored to your taste</small>
            </div>
          </div>

          <div className="d-flex align-items-center mb-3 p-2 rounded-3 upgrade-feature-item">
            <div className="feature-icon-badge bg-primary-subtle p-2 rounded-circle me-3 d-flex align-items-center justify-content-center">
              <i className="fi fi-rr-search text-primary" style={{ fontSize: "1rem" }}></i>
            </div>
            <div>
              <h6 className="mb-0 fw-bold upgrade-feature-title" style={{ fontSize: "0.88rem" }}>Search public recipes</h6>
              <small className="upgrade-feature-desc text-muted">Browse community favorites and save your daily limit</small>
            </div>
          </div>

          <div className="d-flex align-items-center mb-3 p-2 rounded-3 upgrade-feature-item">
            <div className="feature-icon-badge bg-warning-subtle p-2 rounded-circle me-3 d-flex align-items-center justify-content-center">
              <i className="fi fi-rr-apple-whole text-warning" style={{ fontSize: "1rem" }}></i>
            </div>
            <div>
              <h6 className="mb-0 fw-bold upgrade-feature-title" style={{ fontSize: "0.88rem" }}>Daily calorie & nutrition check</h6>
              <small className="upgrade-feature-desc text-muted">Snap food photos to track nutrition effortlessly</small>
            </div>
          </div>

          <div className="upgrade-price-box p-3 rounded-4 mb-3 text-center">
            <h6 className="fw-bold upgrade-price-title mb-1">Recipe AI Pro Yearly</h6>
            <h4 className="fw-bold text-success mb-1">$9.99 <span style={{ fontSize: "0.85rem", fontWeight: "normal" }}>/ Year</span></h4>
            <div className="mt-2">
              <p className="mb-0 upgrade-secure-text" style={{ fontSize: "0.75rem" }}>
                <i className="fi fi-rr-shield-check me-1 text-success"></i> Secure payment via Apple
              </p>
              <p className="text-muted mt-1 mb-0 upgrade-terms-hint" style={{ fontSize: "0.68rem", lineHeight: "1.3" }}>
                Subscription auto-renews annually unless cancelled in your Apple ID Settings at least 24 hours before the end of the current period.
              </p>
            </div>
          </div>

          <button
            className="btn w-100 py-3 rounded-pill fw-bold shadow-sm mb-3 upgrade-cta-btn"
            style={{
              background: "linear-gradient(135deg, #15803d 0%, #16a34a 100%)",
              color: "#ffffff",
              border: "none",
              fontSize: "1rem",
              letterSpacing: "0.3px",
              boxShadow: "0 6px 18px rgba(22, 163, 74, 0.35)"
            }}
            onClick={handleSubscribe}
          >
            <i className="fi fi-rr-star me-2 text-warning"></i> Subscribe Now
          </button>

          <div className="d-flex justify-content-center gap-3 mb-2">
            <button
              className="btn btn-link p-0 text-muted text-decoration-underline"
              style={{ fontSize: "0.75rem" }}
              onClick={() => navigate("/privacypolicy")}
            >
              Privacy Policy
            </button>
            <span className="text-muted" style={{ fontSize: "0.75rem" }}>•</span>
            <a
              href="https://www.apple.com/legal/internet-services/itunes/dev/stdeula/"
              className="text-muted text-decoration-underline"
              style={{ fontSize: "0.75rem" }}
              onClick={(e) => {
                e.preventDefault();
                handleOpenExternal("https://www.apple.com/legal/internet-services/itunes/dev/stdeula/");
              }}
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms of Use (EULA)
            </a>
          </div>

          <button
            className="btn btn-link w-100 text-muted text-decoration-none sm py-1"
            onClick={() => navigate(-1)}
          >
            <small>Maybe Later</small>
          </button>
        </div>

        <div className="card-footer upgrade-pro-footer border-0 p-2.5 text-center">
          <p className="text-muted px-2 mb-0" style={{ fontSize: "0.65rem", lineHeight: "1.3" }}>
            {config.appdescription3}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionUpgrade;
